module.exports = __webpack_public_path__ + "img/time-traveler.af51eb2a.png";